import React,{useEffect,useState} from 'react';
import bgHero from "../Assets/images/sectionthree.png"


const SectionThree = () => {
    const [windowWidth, setWindowWidth] = useState(0);



    let resizeWindow = () => {
        setWindowWidth(window.screen.width);
    };

    useEffect(() => {
        resizeWindow();
        window.addEventListener("resize", resizeWindow);
        return () => window.removeEventListener("resize", resizeWindow);
    }, []);

    return(
        <div
            style={{
                backgroundImage: `url(${bgHero})`,
                backgroundSize: "100%",  // Ensures the image covers the entire div
                backgroundPosition: 'center', // Centers the image
                backgroundRepeat: 'no-repeat', // Prevents tiling

            }}
            className="w-full flex pt-24 pb-24 ">
            <div className='flex flex-col lg:flex-row  lg:items-end justify-center lg:mx-auto lg:w-maxWidth w-full pt-24 pb-24  lg:pt-24 gap-10 lg:gap-0'>
                <div className=" lg:w-2/5 lg:p-0  p-4  flex flex-col gap-5 ">
                    <h2 className="font-roboto text-center text-2xl lg:text-4xl font-light text-primary ">Stay in control of your <b className="font-bold">Cashflows</b></h2>
                    <p className=" font-roboto text-secondary text-center text-lg">
                        Track your receivables and manage your business on the go, get real-time visibility with instant notifications of all your online sales and account settlements.
                    </p>

                </div>

            </div>
        </div>
    );
}

export  default SectionThree